// src/pages/NotFound.jsx
// The 404 page. Rendered by App.js's catch-all route ("*") when no other
// route matches the requested URL.
//
// Editorial framing rather than a generic "page not found", this is an
// archive, the page simply isn't filed here.
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="max-w-wide mx-auto px-6 py-20 md:py-28">
      <p className="label-mono">Filed under</p>
      <h1 className="font-display text-5xl md:text-display leading-tight md:leading-[1.05] font-medium tracking-tight mt-6 mb-10 max-w-3xl">
        The page you requested isn't filed here.
      </h1>
      <p className="text-body text-ink-70 leading-relaxed max-w-2xl mb-12">
        It may have been withdrawn, the URL may be misspelled, or it may simply
        never have existed. The archive is open for reading.
      </p>

      <div className="flex flex-col md:flex-row gap-6 md:gap-10">
        <Link
          to="/"
          className="label-mono border-b border-ink hover:text-oxblood hover:border-oxblood transition-colors pb-1"
        >
          ← To the cover
        </Link>
        <Link
          to="/blogs"
          className="label-mono border-b border-ink hover:text-oxblood hover:border-oxblood transition-colors pb-1"
        >
          Browse the dispatches →
        </Link>
      </div>
    </section>
  );
}
